import React from 'react'
import Helmet from 'react-helmet'
import {
  Compass,
  Book,
  AlertTriangle,
  Info,
  MessageSquare
} from 'react-feather'

import { Page, Section, Container } from '../components/common'
import Header from '../components/Header'
import Meta from '../components/Meta'
import { default as Item } from '../components/MenuItem'

const More = ({ glossary, infoPages, appVersion }) => {
  return (
    <Page bgWhite>
      <Helmet title='More & Settings' />
      <Meta title='More & Settings' />
      <Header small title='More & Settings' />
      <Section thin>
        <Container>
          <Item to='/more/your-location'>
            <Compass /> Your Location
          </Item>
          <Item to='/more/alerts'>
            <AlertTriangle /> Alerts & Notifications
          </Item>
          {glossary.length > 0 && (
            <Item to='/glossary'>
              <Book /> Glossary
            </Item>
          )}

          {infoPages &&
            infoPages.map(infoPage => (
              <Item
                key={`MoreItem-${infoPage.fields.slug}`}
                to={`/${infoPage.fields.slug}`}
              >
                <Info /> {infoPage.fields.title}
              </Item>
            ))}

          <Item to='/more/leave-feedback'>
            <MessageSquare /> Leave Feedback
          </Item>

          {appVersion && (
            <div style={{ padding: '1rem' }}>
              <sub>Version {appVersion}</sub>
            </div>
          )}
        </Container>
      </Section>
    </Page>
  )
}

export default More



// WEBPACK FOOTER //
// ./src/views/More.js